import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {
  CatalogFeedAction,
  CatalogFeedItem,
  CatalogFeedPreviewItem,
  CatalogFeedSliceState,
  RemoteCatalogDataMapping,
} from '../catalogFeed.types';
import {BreadcrumbName} from '../../breadcrumbs/breadcrumbs.enums';
import {FeedRelatedItemMetadata} from '../../relatedItems/relatedItems.types';
import {TaxonomyEntry} from '../../taxonomy/taxonomy.types';
import {Creative} from '../../creatives/creatives.types';

const initialState: CatalogFeedSliceState = {
  catalogFeedData: [],
  productSets: [],
  mappingOptions: [],
  catalogFeedPreviewData: [],
  isCatalogFeedPreviewDataLoading: false,
  selectedCatalogId: null,
  catalogFeedAction: null,
  isLoading: false,
  creatives: [],
  catalogAutoMappingData: null,
};

const catalogFeedSlice = createSlice({
  name: BreadcrumbName.CatalogFeedTab,
  initialState,
  reducers: {
    updateCatalogFeedPreviewDataLoadingState: (state, action: PayloadAction<boolean>) => {
      state.isCatalogFeedPreviewDataLoading = action.payload;
    },
    updateCatalogFeedData: (state, action: PayloadAction<CatalogFeedItem[]>) => {
      state.catalogFeedData = action.payload;
    },
    updateProductSets: (state, action: PayloadAction<FeedRelatedItemMetadata[]>) => {
      state.productSets = action.payload;
    },
    updateLoadingState: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    updateMappingOptions: (state, action: PayloadAction<TaxonomyEntry[]>) => {
      state.mappingOptions = action.payload;
    },
    setSelectedCatalogId: (state, action: PayloadAction<number | null>) => {
      state.selectedCatalogId = action.payload;
    },
    setCatalogFeedAction: (state, action: PayloadAction<CatalogFeedAction | null>) => {
      state.catalogFeedAction = action.payload;
    },
    updateCreatives: (state, action: PayloadAction<Creative[]>) => {
      state.creatives = action.payload;
    },
    updateCatalogFeedPreviewData: (state, action: PayloadAction<CatalogFeedPreviewItem[]>) => {
      state.catalogFeedPreviewData = action.payload;
    },
    updateCatalogAutoMappingData: (state, action: PayloadAction<RemoteCatalogDataMapping>) => {
      state.catalogAutoMappingData = action.payload;
    },
    resetCatalogFeedTab: () => {
      return initialState;
    },
  },
});

export const {
  updateCatalogFeedData,
  updateProductSets,
  updateLoadingState,
  updateMappingOptions,
  setSelectedCatalogId,
  setCatalogFeedAction,
  updateCreatives,
  updateCatalogFeedPreviewData,
  updateCatalogFeedPreviewDataLoadingState,
  updateCatalogAutoMappingData,
} = catalogFeedSlice.actions;

export default catalogFeedSlice.reducer;
